import { extractAgencyFromUrl } from './utils/url';
import { useEnv } from './utils/env';

export const usePortalLink = (portalName) => {
  const agency = extractAgencyFromUrl(window.location.host) || portalName || 'compulse360';
  const env = useEnv({ shortened: true });

  const link =
    env === 'prod' ? `https://${agency}.adportal.io` : `https://${agency}.${env}.adportal.io`;

  return {
    portal: agency,
    link,
  };
};
